/* eslint-disable no-useless-computed-key */
import React, { useState, useEffect, ChangeEvent } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent,
  Grid,
  Paper,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useNotification } from "../../context/notification.context";
import { payments } from "../../api/pays";
import copy from 'clipboard-copy';
import { format } from "date-fns";

type ModalPaymentProps = {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
  onCancel: () => void;
  title: string;
  initialData?: any | null;
  providerID?: number
  files?: any | null;
  isFromPaymentList?: boolean;
  providersList?: any
};

export const ModalPaymentComponent: React.FC<ModalPaymentProps> = ({
  open,
  onClose,
  onSave,
  onCancel,
  title,
  initialData,
  providerID,
  files,
  isFromPaymentList = false,
  providersList
}) => {
  const [formData, setFormData] = useState<any>({});
  const { getError, getSuccess } = useNotification();
  const [checkboxStates, setCheckboxStates] = useState<any>({});
  const [saldoAplicable, setSaldoAplicable] = useState<number>(0);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData({});
      setSaldoAplicable(0);
    }
  }, [initialData]);

  // Function to format numbers with custom separators
  const formatNumber = (number: any) => {
    return number.toLocaleString('es', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true,
      groupingSeparator: '.',
      decimalSeparator: ',',
    });
  };

  function truncate(num: number, places: number) {
    return Math.trunc(num * Math.pow(10, places)) / Math.pow(10, places);
  }

  const handleChange = async (
    event: ChangeEvent<HTMLInputElement | { name: string; value: unknown }> | SelectChangeEvent<any>,
  ) => {
    const { name, value } = event.target as HTMLInputElement;
    await setFormData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === "moneda") {
      if (value === "$")
        setSaldoAplicable((formData["importe"] !== undefined) ? formData["importe"] : 0);
      else
        setSaldoAplicable((formData["importe_usd"] !== undefined) ? formData["importe_usd"] : 0);
    }
    if (name === "valorDeCambio") {
      setFormData((prevData: any) => ({
        ...prevData,
        ["importe_usd"]: truncate(formData["importe"] / parseFloat(value), 2),
      }));
      let suma = 0;
      // eslint-disable-next-line array-callback-return
      files.map((file: any) => {
        suma += (formData["importe_" + file.id] !== undefined && formData["importe_" + file.id] !== "") ? parseFloat(formData["importe_" + file.id]) : 0;
      });
      setSaldoAplicable((parseFloat(formData["importe"]) > 0) ? truncate((formData["importe"] / parseFloat(value)) - suma, 2) : 0);
    }
    if (name === "importe") {
      if (formData["moneda"] === "$" || formData["moneda"] === undefined) {
        let suma = 0;
        // eslint-disable-next-line array-callback-return
        files.map((file: any) => {
          suma += (formData["importe_" + file.id] !== undefined && formData["importe_" + file.id] !== "") ? parseFloat(formData["importe_" + file.id]) : 0;
        });
        setSaldoAplicable((value !== "") ? truncate(parseFloat(value) - suma, 2) : 0 - suma);
      } else {
        setFormData((prevData: any) => ({
          ...prevData,
          ["importe_usd"]: truncate(parseFloat(value) / formData["valorDeCambio"], 2),
        }));
        let suma = 0;
        // eslint-disable-next-line array-callback-return
        files.map((file: any) => {
          suma += (formData["importe_" + file.id] !== undefined && formData["importe_" + file.id] !== "") ? parseFloat(formData["importe_" + file.id]) : 0;
        });
        setSaldoAplicable((formData["valorDeCambio"] !== undefined) ? truncate((parseFloat(value) / formData["valorDeCambio"]) - suma, 2) : 0);
      }
    }
    if (name === "importe_usd" && formData["moneda"] === "U$S") {
      const importe = (value !== "") ? parseFloat(value) : 0;
      setFormData((prevData: any) => ({
        ...prevData,
        ["importe"]: truncate(importe * formData["valorDeCambio"], 2),
      }));
      let suma = 0;
      // eslint-disable-next-line array-callback-return
      files.map((file: any) => {
        suma += (formData["importe_" + file.id] !== undefined && formData["importe_" + file.id] !== "") ? parseFloat(formData["importe_" + file.id]) : 0;
      });
      setSaldoAplicable(truncate(parseFloat(importe.toString()) - suma, 2));
    }
    if (name.includes("importe_") && name !== "importe_usd") {
      let suma = (value !== "") ? parseFloat(value) : 0;
      // eslint-disable-next-line array-callback-return
      files.map((file: any) => {
        if ("importe_" + file.id !== name)
          suma += truncate((formData["importe_" + file.id] !== undefined && formData["importe_" + file.id] !== "") ? parseFloat(formData["importe_" + file.id]) : 0, 2);
      });
      if (formData["moneda"] === "$" || formData["moneda"] === undefined) {
        setSaldoAplicable((formData["importe"] !== undefined && formData["importe"] !== "") ? formData["importe"] - suma : 0 - suma);
      }
      else
        setSaldoAplicable((formData["importe_usd"] !== undefined && formData["importe_usd"] !== "") ? formData["importe_usd"] - suma : 0 - suma);
    }
  };

  const handleSave = (withCopy: boolean) => {
    try {
      let sumImporte = 0;
      // eslint-disable-next-line array-callback-return
      files.map((file: any) => {
        sumImporte += (formData["importe_" + file.id] !== undefined) ? parseFloat(formData["importe_" + file.id]) : 0;
      });
      sumImporte = parseFloat(sumImporte.toFixed(2));
      console.log(saldoAplicable);
      if ((((formData["moneda"] === "$" || formData["moneda"] === undefined) && ((sumImporte !== parseFloat(formData["importe"]) && Math.abs(sumImporte - parseFloat(formData["importe"])) > 0.1) || formData["importe"] === undefined || formData["importe"] === "" || parseFloat(formData["importe"]) === 0))
        || ((formData["moneda"] === "U$S") && ((sumImporte !== parseFloat(formData["importe_usd"]) && Math.abs(sumImporte - parseFloat(formData["importe_usd"])) > 0.1) || formData["importe_usd"] === undefined || formData["importe_usd"] === "" || parseFloat(formData["importe_usd"]) === 0)))) {
        getError("Los importes no coinciden o son nulos. La suma de los importes de cada file seleccionado debe ser igual al importe total del pago.");
      } else {
        let imputacionesPagos: { file: any; cliente: any; importe: string; saldo: any }[] = [];


        // eslint-disable-next-line array-callback-return
        files.map((file: any) => {
          const importe = formData["importe_" + file.id];
          if (importe !== undefined && parseFloat(importe) > 0) {
            const imputacionPago = {
              file: file.file,
              cliente: file.cliente,
              importe: (formData["moneda"] === undefined) ? "$ " + importe : formData["moneda"] + " " + importe,
              saldo: (formData["moneda"] === undefined || formData["moneda"] === "$") ? "$ " + (parseFloat(file.saldo_ars.replace(/\./g, '').replace(',', '.')) - parseFloat(importe)) : "U$S " + (parseFloat(file.saldo_usd.replace(/\./g, '').replace(',', '.')) - parseFloat(importe))
            }
            imputacionesPagos.push(imputacionPago);
          }
        });


        if (withCopy) {
          const moneda = (formData["moneda"] === undefined) ? "$" : formData["moneda"];
          const importe = (moneda === "$") ? moneda + " " + formData["importe"] : moneda + " " + formData["importe_usd"];
          const data = formatDataAsString(importe, imputacionesPagos);
          copy(data);
        }


        // eslint-disable-next-line array-callback-return
        files.map(async (file: any) => {
          const importe = formData["importe_" + file.id];
          if (importe !== undefined && parseFloat(importe) > 0) {
            const producto_id = file.id.split('_');
            let paymentData = {};
            switch (producto_id[0]) {
              case 'h':
                paymentData = {
                  moneda: (formData["moneda"] === undefined) ? "$" : formData["moneda"],
                  importe: importe,
                  proveedorId: providerID,
                  hotelId: producto_id[1],
                  valorDeCambio: (formData["valorDeCambio"] === undefined) ? 1 : formData["valorDeCambio"],
                  observaciones: formData["observaciones"],
                };
                break;
              case 'l':
                paymentData = {
                  moneda: (formData["moneda"] === undefined) ? "$" : formData["moneda"],
                  importe: importe,
                  proveedorId: providerID,
                  aereoId: producto_id[1],
                  valorDeCambio: (formData["valorDeCambio"] === undefined) ? 1 : formData["valorDeCambio"],
                  observaciones: formData["observaciones"],
                };
                break;
              case 's':
                paymentData = {
                  moneda: (formData["moneda"] === undefined) ? "$" : formData["moneda"],
                  importe: importe,
                  proveedorId: providerID,
                  servicioId: producto_id[1],
                  valorDeCambio: (formData["valorDeCambio"] === undefined) ? 1 : formData["valorDeCambio"],
                  observaciones: formData["observaciones"],
                };
                break;
            }
            await payments.create(paymentData);
            //setFormData({});
            //setSaldoAplicable(0);
            window.location.reload();
          }
        });
        getSuccess("Pago agregado correctamente");
        handleClose();
      }
    } catch (error) {
      getError("Error al agregar el pago: " + error);
    }
  };

  const formatDataAsString = (importe: string, imputacionesPagos: any[]) => {
    //format data as string for copy to clipboard
    const moneda = formData["moneda"] || "$";
    const valorDeCambio = formData["valorDeCambio"];
    const importePesos = formData["importe"];
    const importeUsd = formData["importe_usd"];

    // Encabezado
    let formattedString = '';
    if (moneda === "U$S" && importePesos && valorDeCambio && importeUsd) {
      // Si es U$S: mostrar Total pesos, Tipo de cambio, Total dólares
      formattedString += `Total: $ ${importePesos}  \n`;
      formattedString += `Tipo de Cambio: $ ${valorDeCambio}  \n`;
      formattedString += `Total: U$S ${importeUsd}  \n\n`;
    } else {
      // Si es pesos: solo mostrar el total
      formattedString += `Total: ${importe}\n\n`;
    }

    formattedString += '------------------------------------------\n';

    // Imputaciones (sin tipo de cambio repetido)
    imputacionesPagos.forEach((pago) => {
      formattedString += `File: ${pago.file}  \n`;
      formattedString += `Pax: ${pago.cliente}  \n`;
      formattedString += `Importe: ${pago.importe}  \n`;
      formattedString += `Saldo: ${pago.saldo}  \n`;
      formattedString += '------------------------------------------\n';
    });

    return formattedString;
  };

  const handleClose = () => {
    if (!isFromPaymentList) {
      // eslint-disable-next-line array-callback-return
      files.map((file: any) => {
        setCheckboxStates({ ...checkboxStates, ["check_" + file.id]: false });
      })
    }
    setFormData({});
    setSaldoAplicable(0);
    onClose();
  }

  const handleCheckboxChange = (event: any) => {
    const { name, checked } = event.target;
    setCheckboxStates({ ...checkboxStates, [name]: checked });
    const file = name.split("_");
    setFormData((prevData: any) => ({
      ...prevData,
      ["importe_" + file[1] + "_" + file[2]]: ""
    }));
    let suma = (formData["importe_" + file[1] + "_" + file[2]] !== undefined && formData["importe_" + file[1] + "_" + file[2]] !== "") ? -parseFloat(formData["importe_" + file[1] + "_" + file[2]]) : 0;
    // eslint-disable-next-line array-callback-return
    files.map((file: any) => {
      if ("importe_" + file.id !== "importe_" + file[1] + "_" + file[2])
        suma += (formData["importe_" + file.id] !== undefined && formData["importe_" + file.id] !== "") ? parseFloat(formData["importe_" + file.id]) : 0;
    });
    if (formData["moneda"] === "$" || formData["moneda"] === undefined)
      setSaldoAplicable((formData["importe"] !== undefined && formData["importe"] !== "") ? (formData["importe"] - suma) : 0 - suma);
    else
      setSaldoAplicable((formData["importe_usd"] !== undefined && formData["importe_usd"] !== "") ? (formData["importe_usd"] - suma) : 0 - suma);
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container sx={{ mt: 2 }}>
          <Grid item xs={2} sx={{ mr: 2 }}>
            <InputLabel sx={{ mt: 1 }}>
              Moneda
            </InputLabel>
            <Select
              key={`moneda`}
              label={`moneda-label`}
              id={`moneda`}
              name={`moneda`}
              value={formData[`moneda`] || "$"}
              onChange={handleChange}
              fullWidth
            >
              <MenuItem key={"$"} value={"$"} selected={true}>
                {"$"}
              </MenuItem>
              <MenuItem key={"U$S"} value={"U$S"}>
                {"U$S"}
              </MenuItem>
            </Select>
          </Grid>
          <Grid item xs={3} sx={{ mr: 2 }}>
            <InputLabel sx={{ mt: 1 }}>
              Importe $
            </InputLabel>
            <TextField
              key={"importe"}
              name={"importe"}
              fullWidth
              sx={{ mt: 0 }}
              type={"number"}
              onChange={handleChange}
              value={formData[`importe`]}
            />
          </Grid>
          {formData["moneda"] === "U$S" && (
            <>
              <Grid item xs={3} sx={{ mr: 2 }}>
                <InputLabel sx={{ mt: 1 }}>
                  Tipo de Cambio
                </InputLabel>
                <TextField
                  key={"valorDeCambio"}
                  name={"valorDeCambio"}
                  fullWidth
                  sx={{ mt: 0 }}
                  type={"number"}
                  value={formData[`valorDeCambio`]}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={3}>
                <InputLabel sx={{ mt: 1 }}>
                  Conversión U$S
                </InputLabel>
                <TextField
                  key={"importe_usd"}
                  name={"importe_usd"}
                  fullWidth
                  sx={{ mt: 0 }}
                  type={"number"}
                  value={formData[`importe_usd`]}
                  onChange={handleChange}
                />
              </Grid>
            </>
          )}
        </Grid>
        <Grid container sx={{ mt: 2, mb: 2 }}>
          <Grid item xs={12}>
            <InputLabel sx={{ mt: 1 }}>
              Observaciones
            </InputLabel>
            <TextField
              key={"observaciones"}
              name={"observaciones"}
              multiline={true}
              rows={4}
              fullWidth
              sx={{ mt: 0 }}
              onChange={handleChange}
            />
          </Grid>
        </Grid>
        {(!isFromPaymentList) ?
          <>
            <Paper variant="outlined" />
            <Grid container sx={{ mt: 2, mb: 2 }}>
              <Grid item xs={7} display="flex" alignItems="center">
                Seleccione el file a aplicar el importe
              </Grid>
              <Grid item xs={5}>
                Saldo Aplicable:{(formData["moneda"] === "U$S") ? " U$S" : " $"} {formatNumber(saldoAplicable)}
              </Grid>
            </Grid>
            <Grid container sx={{ mt: 2, mb: 2 }} style={{ maxHeight: "300px", overflowY: "auto" }}>
              {
                // eslint-disable-next-line array-callback-return
                files.map((file: any) => {
                  const saldoArsNum = parseInt(file.saldo_ars?.replace(/[^0-9]/g, '') || '0');
                  const saldoUsdNum = parseInt(file.saldo_usd?.replace(/[^0-9]/g, '') || '0');
                  if (saldoArsNum > 0 || saldoUsdNum > 0) {
                    const saldo = (file.saldo_ars !== "") ? " | Saldo ARS: " + file.saldo_ars : " | Saldo USD: " + file.saldo_usd;
                    return <Grid container sx={{ mb: 1 }} key={file.id}>
                      <Grid item xs={8} display="flex" alignItems="center">
                        <FormControlLabel
                          key={"check_" + file.id}
                          name={"check_" + file.id}
                          control={<Checkbox />}
                          label={"File: " + file.file + " (" + format(file.fecha, "dd/MM/yyyy") + ")" + saldo}
                          style={{ justifyContent: "center" }}
                          onChange={handleCheckboxChange}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <TextField
                          key={"importe_" + file.id}
                          name={"importe_" + file.id}
                          sx={{ mt: 0, float: "left" }}
                          type={"number"}
                          onChange={handleChange}
                          disabled={!checkboxStates["check_" + file.id]}
                          label={"Importe"}
                          value={formData["importe_" + file.id]}
                        />
                      </Grid>
                    </Grid>
                  }
                })
              }
            </Grid>
          </>
          : ""
        }
        <Paper variant="outlined" />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} style={{ backgroundColor: "#ed3c3cde", color: "#000000" }}>Cancelar</Button>
        <Button onClick={() => { handleSave(false); }} style={{ backgroundColor: "#6da34cde", color: "#000000" }}>Solo Guardar</Button>
        <Button onClick={() => { handleSave(true); }} style={{ backgroundColor: "#3c8fedde", color: "#000000" }}>Guardar y Copiar Imputaciones</Button>
      </DialogActions>
    </Dialog>
  );
};
